<template>
  <ul class="menu-nav">
    <router-link
      to="/dashboard"
      v-slot="{ href, navigate, isActive, isExactActive }"
      class="d-none">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]">
        <a
          :href="href"
          class="menu-link"
          @click="navigate">
          <span class="menu-text"> Dashboard </span>
        </a>
      </li>
    </router-link>
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-submenu menu-item-open-dropdown d-none"
      v-bind:class="{ 'menu-item-active': hasActiveChildren('/statistics') }">
      <a
        href="#"
        class="menu-link menu-toggle">
        <span class="menu-text"> Statistics </span>
      </a>
      <div class="menu-submenu menu-submenu-classic">
        <ul class="menu-subnav">
          <router-link
            to="/statistics/grafana"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Grafana </span>
              </a>
            </li>
          </router-link>
          <router-link
            to="/statistics/webhooks"
            v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active',
              ]">
              <a
                :href="href"
                class="menu-link"
                @click="navigate">
                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                <span class="menu-text"> Webhooks </span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <router-link
      :to="{ path: '/servers', query: { limit: 10, page: 1, sort: 'created', ord: 'desc' } }"
      v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item ml-0"
        v-bind:class="{ 'menu-item-active': hasActiveChildren('/servers') }">
        <a
          :href="href"
          class="menu-link"
          @click="navigate">
          <span class="menu-text"> Servers </span>
        </a>
      </li>
    </router-link>
    <router-link
      :to="{ path: '/resellers', query: { limit: 10, page: 1, sort: 'created', ord: 'desc' } }"
      v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        v-bind:class="{ 'menu-item-active': hasActiveChildren('/resellers') }">
        <a
          :href="href"
          class="menu-link"
          @click="navigate">
          <span class="menu-text"> Resellers </span>
        </a>
      </li>
    </router-link>
    <router-link
      :to="{ path: '/users', query: usersRouterParams }"
      v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        v-bind:class="{ 'menu-item-active': hasActiveChildren('/users') }">
        <a
          :href="href"
          class="menu-link"
          @click="navigate">
          <span class="menu-text"> Users </span>
        </a>
      </li>
    </router-link>
  </ul>
</template>

<script>
import { DEFAULT_USERS_ROUTER_PARAMS } from '@/core/services/store/users.module'

export default {
  name: 'KTMenu',
  data() {
    return {
      usersRouterParams: { ...DEFAULT_USERS_ROUTER_PARAMS }
    }
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1
    },
  },
}
</script>
